/**
 * Shows whether an appointment/slot is Audio or Video.
 */
function CallTypeBadge({ callType, className = '' }) {
  const isAudio = callType === 'AUDIO';
  return (
    <span
      className={`badge rounded-pill px-3 ${
        isAudio ? 'bg-info text-white' : 'bg-primary text-white'
      } ${className}`.trim()}
    >
      <i className={`bi ${isAudio ? 'bi-telephone-fill' : 'bi-camera-video-fill'} me-1`}></i>
      {isAudio ? 'Audio Call' : 'Video Call'}
    </span>
  );
}

export default CallTypeBadge;
